import { Component, computed, input } from '@angular/core';
import { CardStatus } from '../../../_interfaces/cards.interface';
import { NgClass, SlicePipe } from '@angular/common';
import { EmptyIndicatorPipe } from '../../pipes/empty-indicator.pipe';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-card-number-display',
  standalone: true,
  imports: [SlicePipe, EmptyIndicatorPipe, NgClass, TooltipModule],
  templateUrl: './card-number-display.component.html',
})
export class CardNumberDisplayComponent {
  status = input.required<CardStatus>();
  value = input.required<string>();
  protected readonly CardStatus = CardStatus;

  ui = computed(() => {
    const s = this.status();
    switch (s) {
      case CardStatus.Blocked:
        return { label: 'Blocked', color: 'text-danger', badge: 'bg-danger' };
      case CardStatus.New:
        return { label: 'Pending activation', color: 'text-warning', badge: 'bg-warning' };
      case CardStatus.Removed:
        return { label: 'Removed', color: 'text-muted', badge: 'disabled' };
      default:
        return { label: '', color: 'text-body', badge: '' };
    }
  });

  showTooltip = computed(() => this.status() !== CardStatus.Active);
}
